export default __webpack_public_path__ + "static/media/eth_bull_vault_strategy.aca6e635.gif";